import{a as e}from"./chunk-RAAYCPUM.js";function l(...n){return e(r,n)}var r=n=>"length"in n?n.length:[...n].length;export{l as a};
